var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 318,
    viewBox: "0 0 392 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.151 212.951C114.86 212.952 108.584 212.315 102.421 211.051C90.5263 208.601 79.233 203.825 69.19 196.996C55.2765 187.566 44.1602 174.561 37.0093 159.35C29.8584 144.139 26.937 127.282 28.5522 110.551C30.1673 93.8205 36.2594 77.8339 46.188 64.2713C56.1167 50.7087 69.5154 40.0711 84.976 33.4762C90.5964 31.0892 96.4401 29.2669 102.421 28.0362C112.154 26.0444 122.142 25.616 132.009 26.7672C129.908 31.3622 128.301 36.1671 127.215 41.1012C126.098 46.1922 125.536 51.3892 125.537 56.6012C125.514 70.9083 129.786 84.8929 137.799 96.7452C142.965 104.39 149.548 110.973 157.192 116.139C161.035 118.735 165.121 120.952 169.392 122.759C178.234 126.501 187.739 128.42 197.34 128.401C202.895 128.405 208.432 127.767 213.84 126.501C212.565 144.073 206.338 160.924 195.879 175.101C192.496 179.688 188.703 183.958 184.546 187.857C167.388 204.001 144.71 212.978 121.151 212.951Z",
    fill: "#713FFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.798 106.695C125.66 87.911 132.154 61.1135 119.303 46.8412C106.453 32.569 79.1229 36.2268 58.2609 55.011C37.3988 73.7953 30.9044 100.593 43.7552 114.865C56.6059 129.137 83.9355 125.48 104.798 106.695Z",
    fill: "#A586FC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9868 2L79.0868 9.665L87.4868 12.5L79.0868 15.335L75.9868 23L72.8868 15.335L64.4868 12.5L72.8868 9.665L75.9868 2Z",
    fill: "url(#paint0_linear_4_438)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.987 181L217.552 187.2L224.487 189.5L217.552 191.8L214.987 198L212.422 191.8L205.487 189.5L212.422 187.2L214.987 181Z",
    fill: "url(#paint1_linear_4_438)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.496 25.8661L177.806 31.5134L185.487 31.9701L179.065 36.2081L178.158 43.2541L173.848 37.6067L166.167 37.1501L172.589 32.912L173.496 25.8661Z",
    fill: "url(#paint2_linear_4_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7495 167.063L24.3953 171.439L31.627 170.717L26.0844 175.418L26.0055 181.799L21.3597 177.424L14.128 178.146L19.6706 173.445L19.7495 167.063Z",
    fill: "url(#paint3_linear_4_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.432 88.4751L164.323 89.5124L161.299 94.8079L160.903 88.7228L156.766 85.5508L161.875 84.5135L164.899 79.218L165.295 85.3031L169.432 88.4751Z",
    fill: "url(#paint4_linear_4_438)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_4_438)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_4_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.781 285.765C233.848 285.92 231.895 285.999 229.924 286H92.3999C82.9337 286.035 73.5536 284.201 64.7978 280.603C56.0419 277.005 48.0826 271.714 41.3765 265.032C34.6703 258.351 29.3492 250.412 25.7185 241.669C22.0877 232.927 20.2187 223.554 20.2188 214.087C20.2187 204.621 22.0877 195.248 25.7185 186.506C29.3492 177.763 34.6703 169.824 41.3765 163.143C48.0826 156.461 56.0419 151.17 64.7978 147.572C73.5536 143.974 82.9337 142.14 92.3999 142.175H143.676C160.3 105.6 198.587 80 243.16 80C302.987 80 351.487 126.115 351.487 183C351.487 239.885 302.987 286 243.16 286C240.68 286 238.22 285.922 235.781 285.765Z",
    fill: "url(#paint5_linear_4_438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.159 285C250.445 285 257.726 284.302 264.8 282.926C271.693 281.585 278.473 279.584 284.952 276.978C291.313 274.42 297.447 271.254 303.186 267.568C308.869 263.917 314.213 259.725 319.069 255.107C323.925 250.49 328.333 245.411 332.171 240.009C336.045 234.557 339.372 228.728 342.06 222.686C344.798 216.532 346.9 210.093 348.309 203.547C349.754 196.831 350.487 189.917 350.487 183C350.487 176.082 349.754 169.169 348.309 162.452C346.9 155.906 344.798 149.467 342.06 143.314C339.372 137.272 336.045 131.443 332.171 125.991C328.333 120.589 323.925 115.51 319.069 110.893C314.213 106.275 308.869 102.083 303.186 98.4323C297.447 94.7461 291.313 91.5801 284.952 89.0221C278.473 86.4165 271.693 84.4154 264.8 83.0742C257.726 81.6979 250.445 81 243.159 81C221.789 81 201.149 86.9523 183.473 98.2135C174.953 103.642 167.296 110.194 160.716 117.688C154.095 125.229 148.667 133.607 144.586 142.588L144.319 143.175H143.675H92.3995C82.8259 143.175 73.5393 145.049 64.7974 148.747C60.5958 150.524 56.5432 152.724 52.7523 155.285C48.9972 157.822 45.4659 160.735 42.2567 163.945C39.0475 167.154 36.134 170.685 33.597 174.44C31.0359 178.231 28.8363 182.284 27.0591 186.485C23.3616 195.227 21.4868 204.514 21.4868 214.087C21.4868 223.661 23.3616 232.948 27.0591 241.689C28.8363 245.891 31.0359 249.944 33.597 253.735C36.134 257.49 39.0475 261.021 42.2567 264.23C45.4659 267.439 48.9972 270.353 52.7523 272.89C56.5432 275.451 60.5958 277.651 64.7974 279.428C73.5393 283.125 82.8259 285 92.3995 285H229.924C231.847 285 233.791 284.922 235.701 284.768L235.773 284.762L235.845 284.767C238.264 284.922 240.725 285 243.159 285ZM243.159 286C240.68 286 238.219 285.921 235.781 285.765C233.851 285.92 231.895 286 229.924 286H92.3995C52.6834 286 20.4868 253.803 20.4868 214.087C20.4868 174.371 52.6834 142.175 92.3995 142.175H143.675C160.3 105.595 198.585 80 243.159 80C302.987 80 351.487 126.115 351.487 183C351.487 239.885 302.987 286 243.159 286Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_438",
    x: 24.1191,
    y: 22.1372,
    width: 193.721,
    height: 194.814,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4_438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4_438",
    x: 17.1577,
    y: 18.1353,
    width: 128.743,
    height: 125.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4_438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4_438",
    x: 12.1279,
    y: 0,
    width: 214.359,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4_438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4_438",
    x: 203.487,
    y: 179,
    width: 23,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4_438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_4_438",
    x: 16.2188,
    y: 76,
    width: 339.268,
    height: 218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_438",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_4_438"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_4_438",
    x: 0.21875,
    y: 52,
    width: 391.268,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_438",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_438",
    x1: 75.9868,
    y1: 2,
    x2: 75.9868,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_438",
    x1: 214.987,
    y1: 181,
    x2: 214.987,
    y2: 198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_438",
    x1: 173.496,
    y1: 25.8661,
    x2: 178.158,
    y2: 43.2541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_438",
    x1: 19.7495,
    y1: 167.063,
    x2: 26.0055,
    y2: 181.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_438",
    x1: 169.432,
    y1: 88.4751,
    x2: 156.766,
    y2: 85.5508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_438",
    x1: 154.382,
    y1: 105.956,
    x2: 220.424,
    y2: 297.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.204
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02N);
export default __webpack_public_path__ + "static/media/02n.bd34996234b94990466098d09778e11b.svg";
export { ForwardRef as ReactComponent };